import { CONTRACT_TYPES } from '@constants';

export const generateOpenContractPeriods = () => {
  const months = [];
  months.push({ text: '1 μήνας', value: 1 });

  for (let i = 2; i < 49; i++) {
    months.push({ text: `${i} μήνες`, value: i });
  }
  return months;
};

export const generateMonthsOptions = (length = 48) => {
  const numbers = [];

  for (let i = 1; i <= length; i++) {
    numbers.push({ text: `${i}ος`, value: i });
  }
  return numbers;
};

export const instastartMonths = (contractType, contractPeriod) => {
  if (contractType === CONTRACT_TYPES.open) {
    return [{ text: '19ος', value: 19 }];
  }
  if (contractType === CONTRACT_TYPES.fixed && contractPeriod === 12) {
    return [{ text: '12ος', value: 12 }];
  }
  if (contractType === CONTRACT_TYPES.fixed && contractPeriod === 24) {
    return [
      { text: '12ος', value: 12 },
      { text: '24ος', value: 24 },
    ];
  }
  if (contractType === CONTRACT_TYPES.fixed && contractPeriod === 36) {
    return [
      { text: '12ος', value: 12 },
      { text: '24ος', value: 24 },
      { text: '36ος', value: 36 },
    ];
  }
};
